import request from '@/axios/http'





// 获取缩水师对应的角色列表
export function shrinkage_role_list (data) {
	return request({
		// url: '/stage-api/lottery/shrinkage/role/list',
		url: '/stage-api/lottery/shrinkage/identity/role/list',
		method: 'get',
		data
	})
}
// 获取技巧师对应的角色列表
export function technician_role_list (data) {
	return request({
		url: '/stage-api/lottery/technician/role/list',
		method: 'get',
		data
	})
}
// 获取软件师对应的角色列表
export function software_role_list (data) {
	return request({
		url: '/stage-api/lottery/software/role/list',
		method: 'get',
		data
	})
}

// 申请注册缩水师
export function shrinkage_register (data) {
	return request({
		url: '/stage-api/lottery/shrinkage/identity/register',
		method: 'put',
		data
	})
}
// 技巧师申请
export function technician_register (data) {
	return request({
		url: '/stage-api/lottery/technician/register',
		method: 'put',
		data
	})
}
// 软件师申请
export function software_register (data) {
	return request({
		url: '/stage-api/lottery/software/register',
		method: 'put',
		data
	})
}




// 获取当前登录用户信息
export function shrinkage_identity (data) {
	return request({
		url: '/stage-api/lottery/shrinkage/identity',
		method: 'get',
		data
	})
}






